"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = exports.UserStats = exports.UserStatistic = exports.UserProfileApiWrapper = exports.UserProfile = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _index = _interopRequireDefault(require("../Popup/index"));

var _index2 = _interopRequireDefault(require("../Tabs/index"));

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _UserName = _interopRequireDefault(require("../User/UserName"));

var _ReputationBar = _interopRequireDefault(require("../User/ReputationBar"));

var _getWithInMemoryCache = _interopRequireDefault(require("../../utils/getWithInMemoryCache"));

var _globals3 = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'profile-popup';
exports.cssAnchorName = cssAnchorName;

var UserStatistic = function UserStatistic(_ref) {
  var label = _ref.label,
      value = _ref.value;
  return (0, _preact.h)("div", null, (0, _preact.h)("div", null, value), (0, _preact.h)("div", {
    className: "text--meta"
  }, (0, _preact.h)(_phrase.default, {
    p: label,
    count: {
      value: String(value)
    }
  })));
};

exports.UserStatistic = UserStatistic;

var SendMessageIcon = function SendMessageIcon() {
  return (0, _preact.h)("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, (0, _preact.h)("path", {
    d: "M2 0C.898 0 0 .898 0 2v12c0 1.102.898 2 2 2h6.594c-.102-.3-.094-.7-.094-1 0-.3-.008-.7.094-1H2V2h16v7.188c.8.398 1.398.925 2 1.624V2c0-1.102-.898-2-2-2H2zm1 2.594v2L10 9l7-4.406v-2L10 7 3 2.594zM15 10c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm-1 2h2v2h2v2h-2v2h-2v-2h-2v-2h2v-2z",
    "fill-rule": "nonzero",
    fill: "#000"
  }));
};

var UserStats = function UserStats(_ref2) {
  var user = _ref2.user;
  return (0, _preact.h)("div", {
    style: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between'
    }
  }, [{
    value: user.numberOfTopics,
    label: 'Topic|Topics'
  }, {
    value: user.numberOfReplies,
    label: 'Reply|Replies'
  }, {
    value: user.numberOfSolved,
    label: 'Solved'
  }].map(function (statistic, index) {
    return (0, _preact.h)(UserStatistic, (0, _extends2.default)({
      key: index
    }, statistic));
  }));
};

exports.UserStats = UserStats;

var ExtraUserInfo = function ExtraUserInfo(_ref3) {
  var user = _ref3.user,
      disableTabs = _ref3.disableTabs;

  if (user.showBadges) {
    return (0, _preact.h)(_index2.default, {
      titles: [(0, _preact.h)(_phrase.default, {
        key: 1,
        p: "Badges"
      }), (0, _preact.h)(_phrase.default, {
        key: 2,
        p: "About"
      })],
      style: {
        padding: '20px 0'
      },
      disableClick: disableTabs
    }, (0, _preact.h)(BadgeList, {
      user: user
    }), (0, _preact.h)(ProfileFields, {
      profileFields: user.profileFields
    }));
  }

  return (0, _preact.h)("div", {
    style: {
      paddingTop: '20px'
    }
  }, (0, _preact.h)(ProfileFields, {
    profileFields: user.profileFields
  }));
};

var UserProfile = function UserProfile(_ref4) {
  var profileRef = _ref4.profileRef,
      user = _ref4.user,
      currentUserId = _ref4.currentUserId,
      disableTabs = _ref4.disableTabs,
      isPMActive = _ref4.isPMActive,
      isReputationActive = _ref4.isReputationActive,
      reputationLevel = _ref4.reputationLevel;
  return (0, _preact.h)("div", null, (0, _preact.h)("div", {
    ref: function ref(el) {
      return profileRef(el);
    },
    style: {
      position: 'relative',
      display: 'flex',
      alignItems: 'top',
      width: '100%'
    }
  }, (0, _preact.h)("div", null, (0, _preact.h)(_UserAvatar.default, {
    disablePopup: true,
    showRank: true,
    user: user,
    style: {
      marginBottom: '10px',
      width: '60px',
      height: '60px'
    },
    avatarBaseSize: "64x64",
    width: 60,
    height: 60
  }), isReputationActive && user.showReputation && (0, _preact.h)(_ReputationBar.default, {
    reputationLevel: reputationLevel
  })), (0, _preact.h)("div", {
    style: {
      flexGrow: 1,
      marginLeft: '20px'
    }
  }, (0, _preact.h)(_UserName.default, {
    user: user
  }), (0, _preact.h)("div", {
    className: "text--meta",
    style: {
      marginBottom: '10px'
    }
  }, user.userTitle), (0, _preact.h)(UserStats, {
    user: user
  })), Boolean(isPMActive && currentUserId && currentUserId !== user.id) && (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)((0, _globals3.default)('application') !== 'control' ? "/inbox/conversation?with=".concat(user.id) : "/privateMessages/overview#conversation/".concat(user.id))
  }, (0, _preact.h)(SendMessageIcon, null))), (0, _preact.h)(ExtraUserInfo, {
    user: user,
    disableTabs: disableTabs
  }));
};

exports.UserProfile = UserProfile;

var BadgeList = function BadgeList(_ref5) {
  var user = _ref5.user;
  var badges = user.badges,
      name = user.name;

  if (badges.length) {
    return (0, _preact.h)("div", {
      style: {
        display: 'flex',
        width: '100%',
        alignContent: 'space-around',
        flexWrap: 'wrap'
      }
    }, badges.map(function (_ref6, index) {
      var title = _ref6.title,
          url = _ref6.url;
      return (0, _preact.h)("div", {
        key: index,
        style: {
          float: 'left',
          display: 'flex',
          alignItems: 'center',
          width: '50%',
          paddingRight: index % 2 === 1 ? '5px' : 0,
          paddingTop: index >= 2 ? '8px' : 0
        }
      }, (0, _preact.h)("img", {
        title: title,
        alt: "Badge: ".concat(title),
        src: (0, _absoluteUrlRuntime.resolveUrl)(url),
        style: {
          width: '32px',
          marginRight: '8px'
        }
      }), (0, _preact.h)("div", {
        style: {
          maxWidth: 'calc(100% - 40px)',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      }, title));
    }));
  }

  return (0, _preact.h)(_phrase.default, {
    p: "member.profile.no.badges",
    m: "Common",
    count: {
      username: name
    }
  });
};

var TableRow = function TableRow(_ref7) {
  var value = _ref7.value,
      values = _ref7.values,
      name = _ref7.name;
  return (0, _preact.h)("tr", {
    style: {
      wordWrap: 'break-word'
    }
  }, (0, _preact.h)("td", {
    style: {
      width: '30%',
      verticalAlign: 'top'
    }
  }, name), (0, _preact.h)("td", {
    style: {
      textAlign: 'right',
      width: '70%',
      paddingLeft: '10px',
      verticalAlign: 'top'
    }
  }, value || values.join(', ')));
};

var ProfileFields = function ProfileFields(_ref8) {
  var profileFields = _ref8.profileFields;
  if (!profileFields) return null;
  return (0, _preact.h)("table", {
    style: {
      borderCollapse: 'collapse',
      width: '100%',
      tableLayout: 'fixed'
    }
  }, (0, _preact.h)("tbody", null, profileFields.filter(function (_ref9) {
    var value = _ref9.value,
        values = _ref9.values;
    return value || (values === null || values === void 0 ? void 0 : values.length);
  }).map(function (profileField, index) {
    return (0, _preact.h)(TableRow, (0, _extends2.default)({
      key: index
    }, profileField));
  })));
};

var loadMemberProfile = function loadMemberProfile(memberId, cb, liveData) {
  if (liveData) {
    _getWithInMemoryCache.default.clearCache();
  }

  (0, _getWithInMemoryCache.default)('/member/memberProfile', {
    memberId: memberId
  }).then(cb);
};

var UserProfileApiWrapper = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UserProfileApiWrapper, _Component);

  var _super = _createSuper(UserProfileApiWrapper);

  function UserProfileApiWrapper() {
    var _this;

    (0, _classCallCheck2.default)(this, UserProfileApiWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      user: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "height", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "width", void 0);
    return _this;
  }

  (0, _createClass2.default)(UserProfileApiWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      loadMemberProfile(this.props.memberId, function (user) {
        return _this2.setState({
          user: user
        });
      }, this.props.liveData);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      var _this3 = this;

      loadMemberProfile(props.memberId, function (user) {
        return _this3.setState({
          user: user
        });
      }, props.liveData);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          isReputationActive = _this$props.isReputationActive,
          isPMActive = _this$props.isPMActive,
          liveData = _this$props.liveData,
          reputationLevel = _this$props.reputationLevel;
      var user = this.state.user;
      var currentUserId = parseInt((0, _insidedDataStorage.getInsidedData)('user').userid);

      if (user) {
        return (0, _preact.h)(UserProfile, {
          profileRef: function profileRef(el) {
            return _this4.ref = el;
          },
          user: user,
          currentUserId: currentUserId,
          isPMActive: isPMActive,
          isReputationActive: isReputationActive,
          disableTabs: liveData,
          reputationLevel: reputationLevel
        });
      }

      return (0, _preact.h)("div", {
        className: "generic-loader",
        ref: function ref(el) {
          return _this4.ref = el;
        },
        style: {
          color: '#ccc',
          marginTop: '-15px',
          marginBottom: '15px'
        }
      });
    }
  }]);
  return UserProfileApiWrapper;
}(_preact.Component);

exports.UserProfileApiWrapper = UserProfileApiWrapper;

var ProfilePopup = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(ProfilePopup, _Component2);

  var _super2 = _createSuper(ProfilePopup);

  function ProfilePopup() {
    (0, _classCallCheck2.default)(this, ProfilePopup);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2.default)(ProfilePopup, [{
    key: "render",
    value: function render() {
      var _globals, _globals2;

      var isReputationActive = (_globals = (0, _globals3.default)('activeModules')) === null || _globals === void 0 ? void 0 : _globals.includes('reputation');
      var isPMActive = (_globals2 = (0, _globals3.default)('activeModules')) === null || _globals2 === void 0 ? void 0 : _globals2.includes('privateMessage');
      var element = this.props.hoverControl ? this.props.hoverControl : this.props.parentEl;
      if (!element) return null;
      return (0, _preact.h)(_index.default, {
        hoverControl: element,
        size: {
          width: 400,
          height: 60
        },
        triggerOnClick: this.props.liveData
      }, (0, _preact.h)(UserProfileApiWrapper, {
        isReputationActive: isReputationActive,
        isPMActive: isPMActive,
        memberId: this.props.memberId,
        liveData: this.props.liveData,
        reputationLevel: this.props.reputationLevel
      }));
    }
  }]);
  return ProfilePopup;
}(_preact.Component);

exports.default = ProfilePopup;